import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CanvasService } from '../../../../infrastructure/services/canvas.service';
import { Container } from '../../shared/components/layout_components/container/styles';
import { salvarSessao } from '../reducers/autenticacao.reducer';

const OAuthPage: React.FC = () => {
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'oAuth - SisIEC';

    if (params) {
      const code = params.get('code');
      const error = params.get('error');

      if (code) {
        const canvas_service = new CanvasService();

        canvas_service
          .get_access_token(code)
          .then((data) => {
            dispatch(
              salvarSessao({
                usuario: data.dsc_nome_usuario,
                token: data.token,
                refresh_token: data.refresh_token,
              })
            );

            navigate('/');
          })
          .catch((err) => {
            alert(err.response?.data?.error || err.message);
            navigate('/autenticacao/login');
          });
      }

      if (error) {
        alert(error);
      }
    }
  }, []);

  return <Container />;
};

export { OAuthPage };
